import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=59b2380c"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b2380c')) {
      api.createRecord('59b2380c', component.options)
    } else {
      api.reload('59b2380c', component.options)
    }
    module.hot.accept("./ProductInfo.vue?vue&type=template&id=59b2380c", function () {
      api.rerender('59b2380c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/ProductInfo.vue"
export default component.exports